'use client'

import { useRepoPresence } from '~/hooks-data/use-repo-presence'
import { ClientAvatar } from './client-avatar'
import { Client } from '@basehub/data/replicache/index'

const OthersNav = ({ others }: { others: Client[] }) => {
  if (!others.length) return null

  return (
    <div className="flex gap-1">
      {others.map((client) => {
        return (
          <ClientAvatar
            key={client.id}
            client={client}
            tooltipSide="bottom"
            className="size-navbar-element"
          />
        )
      })}
    </div>
  )
}

export const RepoPresenceNav = () => {
  const { others } = useRepoPresence()

  return <>{others && <OthersNav others={others} />}</>
}
